export default "__VITE_ASSET__D7T6GWKn__"